<ng-container *ngIf="!loading">
  <h2 appDialogTitle class="position-relative" [ngStyle]="data.titleStyle">
    {{ data.title }}
    <app-button size="circle-small" appDialogClose class="small-circle-button">
      <app-icon>close</app-icon>
    </app-button>
  </h2>

  <div class="small-form-field">
    <div [ngStyle]="data.contentStyle">{{ data.content }}</div>
  </div>

  <div appDialogActions align="end">
    <app-button
      variant="ghost-primary"
      *ngIf="!!data.noButton"
      (click)="onNoClicked()"
      cdkFocusInitial
    >
      {{ data.noButton }}
    </app-button>
    <app-button
      variant="ghost-primary"
      *ngIf="!!data.yesButton"
      (click)="onOkClick()"
    >
      {{ data.yesButton }}
    </app-button>
  </div>
</ng-container>

<div *ngIf="loading" class="validation-retry-dialog-loading">
  <app-progress-spinner [diameter]="32" color="primary"></app-progress-spinner>
</div>
